import type { PlaceModel } from 'owa-location-service';
import { getLocationPhoto } from 'owa-location-persona';

export default function getImage(
    place: PlaceModel | undefined,
    setImageUrl: (imageUrl: string) => void
) {
    if (place != undefined) {
        getLocationPhoto(
            place.Coordinates?.Latitude,
            place.Coordinates?.Longitude,
            place?.PlaceDetails?.FormattedAddress ?? '',
            imageUrl => {
                setImageUrl(imageUrl);
            }
        );
    } else {
        setImageUrl('');
    }
}
